/**
 * Koji fajl iz paketa Poreske uprave korisnik bira (ADR-062).
 *
 * PU šalje ZIP sa imenom JID-a (npr. `FB9PVGZT.zip`) i sedam fajlova istog
 * sertifikata. Primamo ceo ZIP (server sam uzima `.nochain.p12`) ili `.p12`/`.pfx`;
 * PEM, CRT i P7B iz istog paketa odbijamo odmah, pre slanja, sa porukom šta treba
 * izabrati. Server isto proverava (`apps/api/src/lib/pfr-cert-package.ts`).
 * Ista pravila kao `src/features/settings/pfr-cert-file.ts` (web) - menjati zajedno.
 */
export const CERT_FILE_ACCEPT = '.zip,.p12,.pfx,application/zip,application/x-pkcs12';

export function certFileHint(name: string): { ok: boolean; text: string } {
  const n = name.toLowerCase();
  if (n.endsWith('.zip')) {
    const jid = /^([a-z0-9]{8})(?: \(\d+\))?\.zip$/.exec(n)?.[1];
    return { ok: true, text: `Paket od Poreske uprave${jid ? ` (JID ${jid.toUpperCase()})` : ''} - iz njega uzimamo .nochain.p12.` };
  }
  if (/\.nochain\.(p12|pfx)$/.test(n)) return { ok: true, text: 'Pravi fajl iz paketa (sertifikat sa ključem).' };
  if (/\.(p12|pfx)$/.test(n)) return { ok: true, text: 'Sertifikat sa ključem (.p12).' };
  if (/\.(pem|crt|cer|der|p7b|p7c|key)$/.test(n)) {
    return { ok: false, text: 'Ovo je isti sertifikat u drugom formatu, koji ne primamo. Izaberite fajl koji se završava sa „.nochain.p12" (1_… u paketu) ili ceo ZIP.' };
  }
  return { ok: false, text: 'Izaberite ZIP koji ste dobili od Poreske uprave ili fajl .p12 iz njega.' };
}
